const PaymentTermsFields = [
  {
    id: Math.random() * 10,
    name: "Payment_Terms",
    fields: [
      {
        id: Math.random() * 10,
        name: "Name",
        label: "Name",
        type: "text",
        min: 1,
        max: Infinity,
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "SP_Advance",
        label: "SP Advance",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "SP_Balance_On",
        label: "SP Balance On",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "SP_Balance",
        label: "SP Balance",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Note",
        label: "Note",
        type: "textarea",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Status",
        label: "Status",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
    ],
  },
];

export { PaymentTermsFields };
